
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor5Off as ObiResistor5OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-5-off.js';
 
 
 

 
 export const ObiResistor5Off = createComponent({
   react: React,
   tagName: 'obi-resistor-5-off',
   elementClass: ObiResistor5OffElement,
   events: {
     
   }
  });
 
 